var _excluded = ["id", "hasError", "size", "resize", "className"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from 'react';
import { string, bool, oneOf } from 'prop-types';
import classNames from 'classnames';
import './TextArea.scss';
var propTypes = {
  /** The ID */
  id: string,

  /** Visual presentation of an error in the input */
  hasError: bool,

  /** The text area can have different sizes. Choose between:  */
  size: oneOf(['small', 'medium', 'large']),

  /** The direction the textarea can be resized  */
  resize: oneOf(['vertical', 'horizontal', 'both', 'none']),

  /** Add your own custom class names to the component */
  className: string
};
var defaultProps = {
  resize: 'vertical',
  size: 'medium'
};
/** The TextArea is a multi-line text input component used for data entry.
 * @visibleName Text Area
 * */

var TextArea = function TextArea(_ref) {
  var id = _ref.id,
      hasError = _ref.hasError,
      size = _ref.size,
      resize = _ref.resize,
      className = _ref.className,
      rest = _objectWithoutProperties(_ref, _excluded);

  var textAreaClassNames = classNames('rds-field rds-textarea', {
    'rds-textarea--danger': hasError,
    'rds-textarea--small': size === 'small',
    'rds-textarea--medium': size === 'medium' || size === '' || size === null,
    'rds-textarea--large': size === 'large',
    'rds-resizable--horizontal': resize === 'horizontal',
    'rds-resizable--vertical': resize === 'vertical' || resize === '' || resize === null,
    'rds-resizable--none': resize === 'none',
    'rds-resizable--both': resize === 'both'
  }, className);
  return /*#__PURE__*/React.createElement("textarea", _extends({
    className: textAreaClassNames,
    id: id
  }, rest, {
    "aria-invalid": hasError
  }));
};

TextArea.propTypes = propTypes;
TextArea.defaultProps = defaultProps;
export default TextArea;